var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Array, Date, Error, Object, RegExp, bemto_settings_default_tag, bemto_settings_element, bemto_settings_modifier, bemto_settings_prefix, inModal, providers, t) {// Cloning via http://stackoverflow.com/a/728694/885556
var clone = function(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = clone(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}

var get_bemto_tag_type = function(tagName) {
  var result = 'block'
  if (bemto_tag_metadata[tagName]) {
    result = bemto_tag_metadata[tagName].type || result;
  }
  return result;
}

var get_bemto_tag_content_type = function(tagName) {
  var result = 'block'
  if (bemto_tag_metadata[tagName]) {
    result = bemto_tag_metadata[tagName].content_type || bemto_tag_metadata[tagName].type || result;
  }
  return result;
}

var bemto_tag_metadata = {
  'hr': {
    'type': 'self_closing'
  },
  'br': {
    'type': 'self_closing'
  },
  'wbr': {
    'type': 'self_closing'
  },
  'source': {
    'type': 'self_closing'
  },
  'img': {
    'type': 'self_closing'
  },
  'input': {
    'type': 'self_closing'
  },
  'a': {
    'type': 'inline'
  },
  'abbr': {
    'type': 'inline'
  },
  'acronym': {
    'type': 'inline'
  },
  'b': {
    'type': 'inline'
  },
  'code': {
    'type': 'inline'
  },
  'em': {
    'type': 'inline'
  },
  'font': {
    'type': 'inline'
  },
  'i': {
    'type': 'inline'
  },
  'ins': {
    'type': 'inline'
  },
  'kbd': {
    'type': 'inline'
  },
  'map': {
    'type': 'inline'
  },
  'pre': {
    'type': 'inline'
  },
  'samp': {
    'type': 'inline'
  },
  'small': {
    'type': 'inline'
  },
  'span': {
    'type': 'inline'
  },
  'strong': {
    'type': 'inline'
  },
  'sub': {
    'type': 'inline'
  },
  'sup': {
    'type': 'inline'
  },
  'textarea': {
    'type': 'inline'
  },
  'time': {
    'type': 'inline'
  },
  'label': {
    'content_type': 'inline'
  },
  'p': {
    'content_type': 'inline'
  },
  'h1': {
    'content_type': 'inline'
  },
  'h2': {
    'content_type': 'inline'
  },
  'h3': {
    'content_type': 'inline'
  },
  'h4': {
    'content_type': 'inline'
  },
  'h5': {
    'content_type': 'inline'
  },
  'h6': {
    'content_type': 'inline'
  },
  'ul': {
    'content_type': 'list'
  },
  'ol': {
    'content_type': 'list'
  },
  'select': {
    'content_type': 'optionlist'
  },
  'datalist': {
    'content_type': 'optionlist'
  }
}


var default_bemto_settings = {
  'prefix': '',
  'element': '__',
  'modifier': '_',
  'default_tag': 'div',
  'nosrc_substitute': true,
  'flat_elements': true,
  'class_delimiter': ''
}

var bemto_output_settings = ['element', 'modifier'];

var bemto_settings = default_bemto_settings;

var get_bemto_settings = function() {
  var settings = clone(bemto_settings);
  if (bemto_settings_prefix      !== undefined) { settings['prefix']      = bemto_settings_prefix;      }
  if (bemto_settings_element     !== undefined) { settings['element']     = bemto_settings_element;     }
  if (bemto_settings_modifier    !== undefined) { settings['modifier']    = bemto_settings_modifier;    }
  if (bemto_settings_default_tag !== undefined) { settings['default_tag'] = bemto_settings_default_tag; }

  for (var i = 0; i < bemto_output_settings.length; i++) {
    var setting = bemto_output_settings[i];
    if (settings['output_' + setting] === undefined) {
      settings['output_' + setting] = settings[setting];
    }
  };

  return settings;
}

var set_bemto_setting = function(name, value) {
  bemto_settings[name] = value;

  //- Resetting the old variable-type setting
  if (name == 'prefix' && bemto_settings_prefix !== undefined) { bemto_settings_prefix = undefined; }
  if (name == 'element' && bemto_settings_element !== undefined) { bemto_settings_element = undefined; }
  if (name == 'modifier' && bemto_settings_modifier !== undefined) { bemto_settings_modifier = undefined; }
  if (name == 'default_tag' && bemto_settings_default_tag !== undefined) { bemto_settings_default_tag = undefined; }
}

var set_bemto_settings = function(settings) {
  for (var name in settings) {
    if (settings.hasOwnProperty(name)) {
      set_bemto_setting(name, settings[name]);
    }
  }
}








pug_mixins["bemto_custom_inline_tag"] = pug_interp = function(customTag, self_closing){
var block = (this && this.block), attributes = (this && this.attributes) || {};
self_closing = self_closing || false
pug_html = pug_html + ((null == (pug_interp = '<') ? "" : pug_interp) + (pug.escape(null == (pug_interp = customTag) ? "" : pug_interp)));
if (attributes) {
for (var attribute in attributes)
{
if (attributes.hasOwnProperty(attribute) && attributes[attribute] !== false && attributes[attribute] !== undefined) {
pug_html = pug_html + ((pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + (pug.escape(null == (pug_interp = attribute) ? "" : pug_interp)) + (null == (pug_interp = '="') ? "" : pug_interp) + (null == (pug_interp = attributes[attribute] === true ? attribute : attributes[attribute]) ? "" : pug_interp) + (null == (pug_interp = '"') ? "" : pug_interp));
}
}
}
if (self_closing) {
pug_html = pug_html + (null == (pug_interp = '/>') ? "" : pug_interp);
}
else {
pug_html = pug_html + (null == (pug_interp = '>') ? "" : pug_interp);
block && block();
pug_html = pug_html + ((null == (pug_interp = '</') ? "" : pug_interp) + (pug.escape(null == (pug_interp = customTag) ? "" : pug_interp)) + (null == (pug_interp = '>') ? "" : pug_interp));
}
};
pug_mixins["bemto_custom_tag"] = pug_interp = function(customTag, tagMetadata){
var block = (this && this.block), attributes = (this && this.attributes) || {};
customTag = customTag || 'div'
tagMetadata = tagMetadata || {}
var selfClosing = false
if (customTag.substr(-1) === '/') {
selfClosing = true
customTag = customTag.slice(0, -1)
}
var tag_type = tagMetadata.type || get_bemto_tag_type(customTag)
switch (tag_type){
case 'inline':
pug_mixins["bemto_custom_inline_tag"].call({
block: function(){
block && block();
},
attributes: attributes
}, customTag);
  break;
case 'self_closing':
pug_mixins["bemto_custom_inline_tag"].call({
attributes: attributes
}, customTag, true);
  break;
default:
if (selfClosing) {
pug_html = pug_html + "\u003C" + (customTag) + (pug.attrs(attributes, true)) + "\u002F\u003E";
}
else {
pug_html = pug_html + "\u003C" + (customTag) + (pug.attrs(attributes, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002F" + (customTag) + "\u003E";
}
  break;
}
};
pug_mixins["bemto_tag"] = pug_interp = function(tag, tagMetadata){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var settings = get_bemto_settings()
tagMetadata = tagMetadata || {}
var newTag = tag || settings['default_tag']
var contextIndex = bemto_chain_contexts.length
if (!tag) {
if (bemto_chain_contexts[contextIndex-1] === 'inline') {
newTag = 'span'
}
else
if (bemto_chain_contexts[contextIndex-1] === 'list') {
newTag = 'li'
}
else
if (bemto_chain_contexts[contextIndex-1] === 'optionlist') {
newTag = 'option'
}
}
if (!tag || tag == 'span' || tag == 'div') {
if (attributes.href) {
newTag = 'a'
}
if (attributes.for) {
newTag = 'label'
}
if (attributes.type) {
newTag = block ? 'button' : 'input'
}
else
if (attributes.src) {
newTag = 'img'
}
}
if (bemto_chain_contexts[contextIndex-1] === 'list' && newTag !== 'li') {
pug_html = pug_html + "\u003Cli\u003E";
}
else
if (bemto_chain_contexts[contextIndex-1] !== 'list' && bemto_chain_contexts[contextIndex-1] !== 'pseudo-list' && newTag === 'li') {
pug_html = pug_html + "\u003Cul\u003E";
bemto_chain_contexts[bemto_chain_contexts.length] = 'pseudo-list'
}
else
if (bemto_chain_contexts[contextIndex-1] === 'pseudo-list' && newTag !== 'li') {
pug_html = pug_html + "\u003C\u002Ful\u003E";
bemto_chain_contexts = bemto_chain_contexts.splice(0,bemto_chain_contexts.length-1)
}
var content_type = tagMetadata.content_type || get_bemto_tag_content_type(newTag)
bemto_chain_contexts[bemto_chain_contexts.length] = content_type
if (newTag == 'img') {
if (attributes.alt && !attributes.title) {
attributes.title = ''
}
if (attributes.title && !attributes.alt) {
attributes.alt = attributes.title
}
if (!attributes.alt) {
attributes.alt = ''
}
if (attributes.alt === '') {
attributes.role = 'presentation'
}
if (!attributes.src) {
if (settings.nosrc_substitute === true) {
attributes.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
}
else
if (settings.nosrc_substitute) {
attributes.src = settings.nosrc_substitute
}
}
}
if (newTag == 'input') {
if (!attributes.type) {
attributes.type = "text"
}
}
if (newTag == 'main') {
if (!attributes.role) {
attributes.role = 'main'
}
}
if (newTag == 'html') {
pug_html = pug_html + "\u003C!DOCTYPE html\u003E";
}
pug_mixins["bemto_custom_tag"].call({
block: function(){
if (block) {
block && block();
}
},
attributes: attributes
}, newTag, tagMetadata);
if (bemto_chain_contexts[contextIndex-1] === 'list' && newTag != 'li') {
pug_html = pug_html + "\u003C\u002Fli\u003E";
}
};
var bemto_chain = []
var bemto_chain_contexts = ['block']
pug_mixins["b"] = pug_interp = function(options){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var settings = get_bemto_settings()
if (options && options.prefix !== undefined) {
settings.prefix = options.prefix
}
var tag = options && options.tag || ( typeof options == 'string' ? options : '')
var isElement = options && options.isElement
var tagMetadata = options && options.metadata
var block_sets_context = false
if (attributes.class) {
var bemto_classes = attributes.class
if (bemto_classes instanceof Array) {
bemto_classes = bemto_classes.join(' ')
}
bemto_classes = bemto_classes.split(' ')
var bemto_objects = []
var is_first_object = true
var new_context = []
// iterate bemto_classes
;(function(){
  var $$obj = bemto_classes;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var klass = $$obj[i];
var bemto_object = {}
var prev_object = bemto_objects[bemto_objects.length - 1]
var sets_context = false
if (klass.match(/^[A-Z-]+[A-Z0-9-]?$/)) {
tag = klass.toLowerCase()
continue
}
if (is_first_object && isElement) {
bemto_object['context'] = bemto_chain[bemto_chain.length - 1]
}
var modifier_class = klass.match(new RegExp('^(?!' + settings['element'] + '[A-Za-z0-9])' + settings['modifier'] + "(.+)$"))
if (modifier_class && prev_object && prev_object.name) {
if (!prev_object['modifiers']) {
prev_object['modifiers'] = []
}
prev_object.modifiers.push(modifier_class[1])
continue
}
var element_class = klass.match(new RegExp('^(?!' + settings['modifier'] + '[A-Za-z0-9])' + settings['element'] + "(.+)$"))
if (element_class) {
bemto_object['context'] = bemto_chain[bemto_chain.length - 1]
klass = element_class[1]
}
var name_with_context = klass.match(new RegExp('^(.*[A-Za-z0-9])(?!' + settings['modifier'] + "$)" + settings['element'] + "$"))
if (name_with_context) {
klass = name_with_context[1]
bemto_object['is_context'] = true
sets_context = true
block_sets_context = true
isElement = false
}
var name_with_modifier = klass.match(new RegExp('^(.*?[A-Za-z0-9])(?!' + settings['element'] + '[A-Za-z0-9])' + settings['modifier'] + "(.+)$"))
if (name_with_modifier) {
klass = name_with_modifier[1]
if (!bemto_object['modifiers']) {
bemto_object['modifiers'] = []
}
bemto_object.modifiers.push(name_with_modifier[2])
}
var found_prefix = ''
var prefix_regex_string = '()?'
if (settings.prefix) {
var prefix = settings.prefix
if (typeof prefix === 'string') {
prefix = { '': prefix }
}
var prefix_regex_test = []
if (prefix instanceof Object) {
// iterate prefix
;(function(){
  var $$obj = prefix;
  if ('number' == typeof $$obj.length) {
      for (var key = 0, $$l = $$obj.length; key < $$l; key++) {
        var value = $$obj[key];
if (typeof key === 'string' && key != '' && prefix_regex_test.indexOf(key) == -1) {
prefix_regex_test.push(key)
}
if (typeof value === 'string' && value != '' && prefix_regex_test.indexOf(value) == -1) {
prefix_regex_test.push(value)
}
      }
  } else {
    var $$l = 0;
    for (var key in $$obj) {
      $$l++;
      var value = $$obj[key];
if (typeof key === 'string' && key != '' && prefix_regex_test.indexOf(key) == -1) {
prefix_regex_test.push(key)
}
if (typeof value === 'string' && value != '' && prefix_regex_test.indexOf(value) == -1) {
prefix_regex_test.push(value)
}
    }
  }
}).call(this);

prefix_regex_string = '(' + prefix_regex_test.join('|') + ')?'
}
var name_with_prefix = klass.match(new RegExp('^' + prefix_regex_string + "([A-Za-z0-9]+.*)$"))
if (name_with_prefix) {
klass = name_with_prefix[2]
found_prefix = name_with_prefix[1] || ''
found_prefix = prefix[found_prefix]
if (found_prefix === undefined || found_prefix === true) {
found_prefix = name_with_prefix[1]
}
}
}
bemto_object['prefix'] = (found_prefix || '').replace(/\-/g, '%DASH%').replace(/\_/g, '%UNDERSCORE%')
if (sets_context && klass.match(/^[a-zA-Z0-9]+.*/)) {
new_context.push(bemto_object.context ? (bemto_object.context + settings['element'] + klass) : (bemto_object.prefix + klass))
}
bemto_object['name'] = klass
is_first_object = false
if (bemto_object.context && bemto_object.context.length > 1) {
// iterate bemto_object.context
;(function(){
  var $$obj = bemto_object.context;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var subcontext = $$obj[i];
var sub_object = clone(bemto_object)
sub_object['context'] = [subcontext]
bemto_objects.push(sub_object)
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var subcontext = $$obj[i];
var sub_object = clone(bemto_object)
sub_object['context'] = [subcontext]
bemto_objects.push(sub_object)
    }
  }
}).call(this);

}
else {
bemto_objects.push(bemto_object)
}
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var klass = $$obj[i];
var bemto_object = {}
var prev_object = bemto_objects[bemto_objects.length - 1]
var sets_context = false
if (klass.match(/^[A-Z-]+[A-Z0-9-]?$/)) {
tag = klass.toLowerCase()
continue
}
if (is_first_object && isElement) {
bemto_object['context'] = bemto_chain[bemto_chain.length - 1]
}
var modifier_class = klass.match(new RegExp('^(?!' + settings['element'] + '[A-Za-z0-9])' + settings['modifier'] + "(.+)$"))
if (modifier_class && prev_object && prev_object.name) {
if (!prev_object['modifiers']) {
prev_object['modifiers'] = []
}
prev_object.modifiers.push(modifier_class[1])
continue
}
var element_class = klass.match(new RegExp('^(?!' + settings['modifier'] + '[A-Za-z0-9])' + settings['element'] + "(.+)$"))
if (element_class) {
bemto_object['context'] = bemto_chain[bemto_chain.length - 1]
klass = element_class[1]
}
var name_with_context = klass.match(new RegExp('^(.*[A-Za-z0-9])(?!' + settings['modifier'] + "$)" + settings['element'] + "$"))
if (name_with_context) {
klass = name_with_context[1]
bemto_object['is_context'] = true
sets_context = true
block_sets_context = true
isElement = false
}
var name_with_modifier = klass.match(new RegExp('^(.*?[A-Za-z0-9])(?!' + settings['element'] + '[A-Za-z0-9])' + settings['modifier'] + "(.+)$"))
if (name_with_modifier) {
klass = name_with_modifier[1]
if (!bemto_object['modifiers']) {
bemto_object['modifiers'] = []
}
bemto_object.modifiers.push(name_with_modifier[2])
}
var found_prefix = ''
var prefix_regex_string = '()?'
if (settings.prefix) {
var prefix = settings.prefix
if (typeof prefix === 'string') {
prefix = { '': prefix }
}
var prefix_regex_test = []
if (prefix instanceof Object) {
// iterate prefix
;(function(){
  var $$obj = prefix;
  if ('number' == typeof $$obj.length) {
      for (var key = 0, $$l = $$obj.length; key < $$l; key++) {
        var value = $$obj[key];
if (typeof key === 'string' && key != '' && prefix_regex_test.indexOf(key) == -1) {
prefix_regex_test.push(key)
}
if (typeof value === 'string' && value != '' && prefix_regex_test.indexOf(value) == -1) {
prefix_regex_test.push(value)
}
      }
  } else {
    var $$l = 0;
    for (var key in $$obj) {
      $$l++;
      var value = $$obj[key];
if (typeof key === 'string' && key != '' && prefix_regex_test.indexOf(key) == -1) {
prefix_regex_test.push(key)
}
if (typeof value === 'string' && value != '' && prefix_regex_test.indexOf(value) == -1) {
prefix_regex_test.push(value)
}
    }
  }
}).call(this);

prefix_regex_string = '(' + prefix_regex_test.join('|') + ')?'
}
var name_with_prefix = klass.match(new RegExp('^' + prefix_regex_string + "([A-Za-z0-9]+.*)$"))
if (name_with_prefix) {
klass = name_with_prefix[2]
found_prefix = name_with_prefix[1] || ''
found_prefix = prefix[found_prefix]
if (found_prefix === undefined || found_prefix === true) {
found_prefix = name_with_prefix[1]
}
}
}
bemto_object['prefix'] = (found_prefix || '').replace(/\-/g, '%DASH%').replace(/\_/g, '%UNDERSCORE%')
if (sets_context && klass.match(/^[a-zA-Z0-9]+.*/)) {
new_context.push(bemto_object.context ? (bemto_object.context + settings['element'] + klass) : (bemto_object.prefix + klass))
}
bemto_object['name'] = klass
is_first_object = false
if (bemto_object.context && bemto_object.context.length > 1) {
// iterate bemto_object.context
;(function(){
  var $$obj = bemto_object.context;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var subcontext = $$obj[i];
var sub_object = clone(bemto_object)
sub_object['context'] = [subcontext]
bemto_objects.push(sub_object)
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var subcontext = $$obj[i];
var sub_object = clone(bemto_object)
sub_object['context'] = [subcontext]
bemto_objects.push(sub_object)
    }
  }
}).call(this);

}
else {
bemto_objects.push(bemto_object)
}
    }
  }
}).call(this);

if (!isElement && !new_context.length && bemto_objects[0] && bemto_objects[0].name && bemto_objects[0].name.match(/^[a-zA-Z0-9]+.*/)) {
bemto_objects[0]['is_context'] = true
new_context.push(bemto_objects[0].context ? (bemto_objects[0].context + settings['element'] + bemto_objects[0].name) : (bemto_objects[0].prefix + bemto_objects[0].name))
block_sets_context = true
}
if (new_context.length) {
if (settings.flat_elements) {
// iterate new_context
;(function(){
  var $$obj = new_context;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var subcontext = $$obj[i];
var context_with_element = subcontext.match(new RegExp('^(.*?[A-Za-z0-9])(?!' + settings['modifier'] + '[A-Za-z0-9])' + settings['element'] + ".+$"))
if (context_with_element) {
new_context[i] = context_with_element[1]
}
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var subcontext = $$obj[i];
var context_with_element = subcontext.match(new RegExp('^(.*?[A-Za-z0-9])(?!' + settings['modifier'] + '[A-Za-z0-9])' + settings['element'] + ".+$"))
if (context_with_element) {
new_context[i] = context_with_element[1]
}
    }
  }
}).call(this);

}
bemto_chain[bemto_chain.length] = new_context
}
if (bemto_objects.length) {
var new_classes = []
// iterate bemto_objects
;(function(){
  var $$obj = bemto_objects;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var bemto_object = $$obj[pug_index6];
if (bemto_object.name) {
var start = bemto_object.prefix
if (bemto_object.context) {
start = bemto_object.context + settings.output_element
}
new_classes.push(start + bemto_object.name)
if (bemto_object.modifiers) {
// iterate bemto_object.modifiers
;(function(){
  var $$obj = bemto_object.modifiers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var modifier = $$obj[pug_index7];
new_classes.push(start + bemto_object.name + settings.output_modifier + modifier)
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var modifier = $$obj[pug_index7];
new_classes.push(start + bemto_object.name + settings.output_modifier + modifier)
    }
  }
}).call(this);

}
}
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var bemto_object = $$obj[pug_index6];
if (bemto_object.name) {
var start = bemto_object.prefix
if (bemto_object.context) {
start = bemto_object.context + settings.output_element
}
new_classes.push(start + bemto_object.name)
if (bemto_object.modifiers) {
// iterate bemto_object.modifiers
;(function(){
  var $$obj = bemto_object.modifiers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index8 = 0, $$l = $$obj.length; pug_index8 < $$l; pug_index8++) {
        var modifier = $$obj[pug_index8];
new_classes.push(start + bemto_object.name + settings.output_modifier + modifier)
      }
  } else {
    var $$l = 0;
    for (var pug_index8 in $$obj) {
      $$l++;
      var modifier = $$obj[pug_index8];
new_classes.push(start + bemto_object.name + settings.output_modifier + modifier)
    }
  }
}).call(this);

}
}
    }
  }
}).call(this);

var delimiter = settings.class_delimiter
delimiter = delimiter ? (' ' + delimiter + ' ') : ' '
attributes.class = new_classes.join(delimiter).replace(/%DASH%/g, '-').replace(/%UNDERSCORE%/g, '_')
}
else {
attributes.class = undefined
}
}
if (block) {
pug_mixins["bemto_tag"].call({
block: function(){
block && block();
},
attributes: attributes
}, tag, tagMetadata);
}
else {
pug_mixins["bemto_tag"].call({
attributes: attributes
}, tag, tagMetadata);
}
if (!isElement && block_sets_context) {
bemto_chain = bemto_chain.splice(0,bemto_chain.length-1)
}
bemto_chain_contexts = bemto_chain_contexts.splice(0,bemto_chain_contexts.length-1)
};
pug_mixins["e"] = pug_interp = function(options){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (options && typeof options == 'string') {
options = { 'tag': options }
}
else {
options = options || {}
}
options['isElement'] = true
pug_mixins["b"].call({
block: function(){
block && block();
},
attributes: attributes
}, options);
};
pug_mixins["b"].call({
block: function(){
pug_mixins["e"].call({
block: function(){
if (inModal) {
pug_mixins["e"].call({
block: function(){
pug_mixins["e"].call({
block: function(){
pug_html = pug_html + (pug.escape(null == (pug_interp = t('auth.signup_form.title')) ? "" : pug_interp));
},
attributes: {"class": "title"}
}, 'h4');
pug_mixins["e"].call({
block: function(){
pug_html = pug_html + "\u002F";
},
attributes: {"class": "header-delimiter"}
});
pug_mixins["e"].call({
block: function(){
pug_mixins["e"].call({
block: function(){
pug_html = pug_html + (pug.escape(null == (pug_interp = t('auth.signup_form.login_link')) ? "" : pug_interp));
},
attributes: {"class": "button-link __login","type": "button","data-switch": "login-form"}
}, 'button');
},
attributes: {"class": "header-aside"}
});
},
attributes: {"class": "line __header"}
});
}
else {
pug_html = pug_html + "\u003Cp\u003E" + (pug.escape(null == (pug_interp = t('auth.signup_form.if_you_already_have_account')) ? "" : pug_interp)) + "&nbsp;";
pug_mixins["e"].call({
block: function(){
pug_html = pug_html + (pug.escape(null == (pug_interp = t('auth.signup_form.login')) ? "" : pug_interp));
},
attributes: {"class": "button-link","type": "button","data-switch": "login-form"}
}, 'button');
pug_html = pug_html + "\u003C\u002Fp\u003E";
}
pug_mixins["e"].call({
block: function(){
pug_mixins["e"].call({
attributes: {"class": "line __notification","data-notification": pug.escape(true)}
});
pug_mixins["e"].call({
block: function(){
pug_mixins["e"].call({
block: function(){
pug_mixins["e"].call({
block: function(){
pug_html = pug_html + (pug.escape(null == (pug_interp = t('auth.email_field_label')) ? "" : pug_interp)) + ":";
},
attributes: {"class": "label","for": "register-email"}
}, 'label');
pug_mixins["b"].call({
block: function(){
pug_mixins["e"].call({
attributes: {"class": "control","id": "register-email","name": "email","type": "email","required": pug.escape(true),"autofocus": pug.escape(true)}
}, 'input');
},
attributes: {"class": "text-input __input"}
}, 'span');
},
attributes: {"class": "form-control"}
});
pug_mixins["e"].call({
block: function(){
pug_mixins["e"].call({
block: function(){
pug_html = pug_html + (pug.escape(null == (pug_interp = t('auth.signup_form.displayName_field_label')) ? "" : pug_interp)) + ":";
},
attributes: {"class": "label","for": "register-displayName"}
}, 'label');
pug_mixins["b"].call({
block: function(){
pug_mixins["e"].call({
attributes: {"class": "control","id": "register-displayName","name": "displayName","required": pug.escape(true)}
}, 'input');
},
attributes: {"class": "text-input __input"}
}, 'span');
},
attributes: {"class": "form-control"}
});
pug_mixins["e"].call({
block: function(){
pug_mixins["e"].call({
block: function(){
pug_html = pug_html + (pug.escape(null == (pug_interp = t('auth.password_field_label')) ? "" : pug_interp)) + ":";
},
attributes: {"class": "label","for": "register-password"}
}, 'label');
pug_mixins["b"].call({
block: function(){
pug_mixins["e"].call({
attributes: {"class": "control","id": "register-password","type": "password","name": "password","required": pug.escape(true),"minlength": "4"}
}, 'input');
},
attributes: {"class": "text-input __input"}
}, 'span');
},
attributes: {"class": "form-control"}
});
},
attributes: {"class": "line __row"}
});
pug_mixins["e"].call({
block: function(){
pug_mixins["e"].call({
block: function(){
pug_mixins["e"].call({
attributes: {"class": "agreement-control","id": "accept-agreement","type": "checkbox","data-action-accept-agreements": pug.escape(true)}
}, 'input');
pug_html = pug_html + (null == (pug_interp = t('auth.signup_form.register_accept')) ? "" : pug_interp);
},
attributes: {"class": "agreement-label","for": "accept-agreement"}
}, 'label');
},
attributes: {"class": "line __agreement"}
});
pug_mixins["e"].call({
block: function(){
pug_mixins["e"].call({
attributes: {"class": "captcha"}
});
},
attributes: {"class": "line"}
});
pug_mixins["e"].call({
block: function(){
pug_mixins["b"].call({
block: function(){
pug_mixins["e"].call({
block: function(){
pug_html = pug_html + (pug.escape(null == (pug_interp = t('auth.signup_form.signup')) ? "" : pug_interp));
},
attributes: {"class": "text"}
}, 'span');
},
attributes: {"class": "button _action submit","type": "submit","disabled": "true"}
}, 'button');
if (inModal) {
pug_mixins["e"].call({
block: function(){
pug_html = pug_html + (pug.escape(null == (pug_interp = t('auth.signup_form.cancel')) ? "" : pug_interp));
},
attributes: {"class": "close-link tablet-only modal__close","href": "#"}
}, 'a');
}
},
attributes: {"class": "line __footer"}
});
pug_mixins["e"].call({
block: function(){
pug_mixins["e"].call({
block: function(){
pug_html = pug_html + (pug.escape(null == (pug_interp = t('auth.login_form.login_using_socialnetworks')) ? "" : pug_interp));
},
attributes: {"class": "social-logins-title"}
}, 'h5');
pug_html = pug_html + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp));
// iterate providers
;(function(){
  var $$obj = providers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index9 = 0, $$l = $$obj.length; pug_index9 < $$l; pug_index9++) {
        var provider = $$obj[pug_index9];
let classes = ['social-login', '_' + provider.id, '__social-login']
pug_mixins["b"].call({
block: function(){
pug_html = pug_html + (pug.escape(null == (pug_interp = provider.name) ? "" : pug_interp));
},
attributes: {"class": pug.classes([classes], [true]),"data-provider": pug.escape(provider.id)}
}, 'button');
pug_html = pug_html + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp));
      }
  } else {
    var $$l = 0;
    for (var pug_index9 in $$obj) {
      $$l++;
      var provider = $$obj[pug_index9];
let classes = ['social-login', '_' + provider.id, '__social-login']
pug_mixins["b"].call({
block: function(){
pug_html = pug_html + (pug.escape(null == (pug_interp = provider.name) ? "" : pug_interp));
},
attributes: {"class": pug.classes([classes], [true]),"data-provider": pug.escape(provider.id)}
}, 'button');
pug_html = pug_html + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp));
    }
  }
}).call(this);

},
attributes: {"class": "line __social-logins"}
});
},
attributes: {"class": "body"}
});
},
attributes: {"class": "form","action": "#","data-form": "register"}
}, 'form');
},
attributes: {"class": pug.classes([['login-form', (inModal ? '_modal' : '_inline')]], [true])}
});}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"Date" in locals_for_with?locals_for_with.Date:typeof Date!=="undefined"?Date:undefined,"Error" in locals_for_with?locals_for_with.Error:typeof Error!=="undefined"?Error:undefined,"Object" in locals_for_with?locals_for_with.Object:typeof Object!=="undefined"?Object:undefined,"RegExp" in locals_for_with?locals_for_with.RegExp:typeof RegExp!=="undefined"?RegExp:undefined,"bemto_settings_default_tag" in locals_for_with?locals_for_with.bemto_settings_default_tag:typeof bemto_settings_default_tag!=="undefined"?bemto_settings_default_tag:undefined,"bemto_settings_element" in locals_for_with?locals_for_with.bemto_settings_element:typeof bemto_settings_element!=="undefined"?bemto_settings_element:undefined,"bemto_settings_modifier" in locals_for_with?locals_for_with.bemto_settings_modifier:typeof bemto_settings_modifier!=="undefined"?bemto_settings_modifier:undefined,"bemto_settings_prefix" in locals_for_with?locals_for_with.bemto_settings_prefix:typeof bemto_settings_prefix!=="undefined"?bemto_settings_prefix:undefined,"inModal" in locals_for_with?locals_for_with.inModal:typeof inModal!=="undefined"?inModal:undefined,"providers" in locals_for_with?locals_for_with.providers:typeof providers!=="undefined"?providers:undefined,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined));;return pug_html;};
module.exports = template;